import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { CPESharedModule } from '../shared/shared.module';
import { UIModule } from 'libs/ui';
import { PumpScheduleModule } from '../pump-schedule/pump-schedule.module';
import {
  StageInfoComponent,
  StageComponent,
  StageEventComponent,
  StageFluidComponent,
  StageFluidMaterialComponent,
  ShoeTrackComponent,
  LinerComponent
} from './components';
import { VIDASharedModule } from 'libs/shared/vida-shared.module';
import { FluidsModule } from '../fluids/fluids.module';
import { TabsModule } from 'primeng/tabs';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputMaskModule } from 'primeng/inputmask';
import { PopoverModule } from 'primeng/popover';
import { CheckboxModule } from 'primeng/checkbox';
import { ContextMenuModule } from 'primeng/contextmenu';
import {MenuModule} from 'primeng/menu';
import { PumpScheduleAdapter } from '../pump-schedule/adapters';
import { PumpScheduleService, PumpScheduleLogic, MudTypeService } from '../pump-schedule/services';
import { FluidsAdapter } from '../fluids/adapters';
import { SvgIconComponent } from 'apps/vida/src/modules/pump/components/mix-on-the-fly/svg-icon.component';
import { MixOnTheFlyComponent } from 'apps/vida/src/modules/pump/components/mix-on-the-fly/mix-on-the-fly.component';
import { JobTotalsComponent } from './components/job-totals/job-totals.component';

const thirdPartyModules = [
  CommonModule,
  TabsModule,
  AutoCompleteModule,
  InputMaskModule,
  PopoverModule,
  CheckboxModule,
  ContextMenuModule,
  MenuModule
];

const services = [
  PumpScheduleService,
  PumpScheduleLogic,
  MudTypeService,
  FluidsAdapter
];

const adapters = [
  PumpScheduleAdapter
];

const components = [
  LinerComponent,
  StageComponent,
  StageInfoComponent,
  StageEventComponent,
  StageFluidComponent,
  StageFluidMaterialComponent,
  ShoeTrackComponent,
  JobTotalsComponent
];

const standaloneComponents = [
  SvgIconComponent,
  MixOnTheFlyComponent
];

@NgModule({
  imports: [
    ...thirdPartyModules,
    UIModule,
    CPESharedModule,
    VIDASharedModule,
    FluidsModule,
    FormsModule,
    PumpScheduleModule,
    ...standaloneComponents
  ],
  declarations: [
    ...components,
  ],
  exports: [
    ...components,
    ...standaloneComponents
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PumpModule {
  static forRoot(): ModuleWithProviders<PumpModule> {
    return {
      ngModule: PumpModule,
      providers: [
        ...services,
        ...adapters,
      ]
    };
  }
}
